import { render, staticRenderFns } from "./MenuProductBox.vue?vue&type=template&id=380c23ae"
import script from "./MenuProductBox.vue?vue&type=script&lang=ts"
export * from "./MenuProductBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports